const getSuppliers = (state) => state.filters.filterContent?.Suppliers;
const getAppliesFilter = (state) => state.filters.filterContent?.SelectedFilters;
const geSupplierPagination = (state) => state.filters.filterContent?.Items;

export { getAppliesFilter, getSuppliers, geSupplierPagination };
